"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMemberRequest = void 0;
var error_1 = require("./error");
var UpdateMemberRequest = /** @class */ (function () {
    function UpdateMemberRequest(_a) {
        var vault = _a.vault, memberName = _a.memberName, avatar = _a.avatar, contact = _a.contact;
        this.wallet = vault.getWallet().identity;
        this.memberName = memberName;
        this.avatar = avatar;
        this.contact = contact;
        if (!this.wallet || this.wallet.length < 42 || this.wallet.length > 46) {
            throw new error_1.ValidationError("Received an update member request. Rejected request because the wallet identifier has a wrong length.");
        }
        if (!this.memberName) {
            throw new error_1.ValidationError("Received a request to create a sign-up request. Rejecting it because a member name is required.");
        }
    }
    return UpdateMemberRequest;
}());
exports.UpdateMemberRequest = UpdateMemberRequest;
//# sourceMappingURL=updateMemberRequest.js.map